import { createContext, useContext } from "react";
import type { UserRole } from "@textformatter/shared";

export type AuthUser = {
  id: string;
  email: string;
  role: UserRole;
  hasPasswordAuth: boolean;
  hasGoogleAuth: boolean;
} | null;

export type AuthContextValue = {
  user: AuthUser;
  loading: boolean;
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  refresh: () => Promise<void>;
};

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
